var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 27C22.0751 27 27 22.0751 27 16C27 9.92487 22.0751 5 16 5C9.92487 5 5 9.92487 5 16C5 22.0751 9.92487 27 16 27ZM21.5 16.7681C21.9418 16.7681 22.3 16.4099 22.3 15.9681C22.3 15.5263 21.9418 15.1681 21.5 15.1681H16.8V10.4681C16.8 10.0263 16.4418 9.66812 16 9.66812C15.5582 9.66812 15.2 10.0263 15.2 10.4681V15.1681L10.5 15.1681C10.0582 15.1681 9.7 15.5263 9.7 15.9681C9.7 16.4099 10.0582 16.7681 10.5 16.7681H15.2L15.2 21.4681C15.2 21.9099 15.5582 22.2681 16 22.2681C16.4418 22.2681 16.8 21.9099 16.8 21.4681V16.7681H21.5Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.8dec630b72da36f91b6ecedcc6c73c11.svg";
export { ForwardRef as ReactComponent };